import React, { useEffect } from 'react';
import ReactEcharts from 'echarts-for-react';
import { connect } from 'react-redux';

const AllocationsChart = ({ data, index, availableRiskProfiles, height = 200 }) => {

    useEffect(() => {

    }, []);

    const getAssetClassChart = (data, index) => {

        const names = ['Equity', 'Fixed Income']

        const option = {
            color: ['#050139', '#0DCCD3', '#0047BB', '#F4F4F4', '#FFFFFF'],
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
                show: false,
                data: names
            },
            series: [
                {
                    name: 'Asset Classes',
                    type: 'pie',
                    radius: ['30%', '70%'], // Adjust the radius to make it a donut chart- ist number
                    data: names.map((name, index) => ({
                        value: data[index],
                        name: name
                    })),
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        show: false,
                        formatter: '{b}: {d}%'
                    }
                }
            ]
        };

        return option;
    }

    return (
        <ReactEcharts
            option={getAssetClassChart(data, index)}
            theme='default'
            style={{
                height,
                width: '90%', // make the chart take up 90% of the parent container's width
                marginRight: '0px',
                paddingLeft: '0px',
                marginLeft: '0px',
                marginTop: -10,
                marginBottom: 10,
                borderRadius: 0,
                // boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)'
            }}
        />
    );
};

const mapStateToProps = state => ({
    availableRiskProfiles: state.data.riskProfiles,
});

export default connect(mapStateToProps)(AllocationsChart);